import { styled } from '@mui/system';

export const StyledLoader = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  '& .MuiCircularProgress-root': {
    color: 'white',
  }
}));
export const StyledLoaderWrap = styled('div')(({theme}) => ({
  '&.loader_block': {
    position: 'fixed',
    left: '0%',
    top: '0%',
    width: '100%',
    height: '100% !important',
    zIndex: '9999',
    background: `${theme.palette.customColor.backdrop}`,
  },
  '&.hide-display': {
    display: 'none'
  }
}));
